import React, { useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { deleteAllQuestionService } from "./services/dataService";
import { notifyAllDeleteSucess, notifyError } from "./helper";

const FieldDeleteModal = ({
  showDeleteModal,
  setShowDeleteModal,
  creator,
  setSurveyJson,
  questionnaireId,
  setLoad,
  loadQuestionData,
}) => {
  const deleteAllFields = useCallback(async () => {
    try {
      setLoad(true);
      creator.JSON = {
        pages: [{ name: "page1", title: "Page Container", elements: [] }],
      };
      setShowDeleteModal(false);
      setSurveyJson({
        pages: [{ name: "page1", title: "Page Container", elements: [] }],
      });
      const res = await deleteAllQuestionService(questionnaireId);
      if (res?.data?.status === "Success") {
        notifyAllDeleteSucess();
        loadQuestionData(questionnaireId);
      }
      console.log("Response", res);
    } catch (err) {
      console.log("Error: ", err);
      notifyError(err?.message);
    } finally {
      setLoad(false);
    }
  }, [creator, setShowDeleteModal]);

  return (
    <Dialog
      open={showDeleteModal}
      onClose={() => setShowDeleteModal(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          pb: 1,
          color: "#d32f2f",
          fontSize: "2.25rem",
          fontWeight: 600,
        }}
      >
        <DeleteOutlineIcon sx={{ fontSize: "2.55rem" }} />
        Delete Fields
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <DialogContentText sx={{ color: "#666", fontSize: "2rem" }}>
          Are you sure you want to delete all fields? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={() => setShowDeleteModal(false)}
          variant="outlined"
          sx={{ textTransform: "none", fontSize: "1.5rem" }}
        >
          Cancel
        </Button>
        <Button
          onClick={deleteAllFields}
          variant="contained"
          color="error"
          sx={{ textTransform: "none", fontSize: "1.5rem" }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(FieldDeleteModal);
